import { zodSchemes } from '@approvalmax/utils';
import { CountryIsoCode, LegalEntityType } from 'shared/data/walletsKyc/v1';
import { z } from 'zod';

import { today } from '../../resources/constants';
import { excludeTimeFromDate } from '../../resources/helpers';
import { messages } from './messages';

export const schema = z
    .object({
        businessInformation: z
            .object({
                companyName: zodSchemes.required.textField.string(),
                tradingName: zodSchemes.optional.textField.string.nullable(),
                businessCountry: z.nativeEnum(CountryIsoCode, {
                    invalid_type_error: messages.requiredField,
                    required_error: messages.requiredField,
                }),
                legalEntityType: zodSchemes.required.select.enum(LegalEntityType),
                vatNumber: zodSchemes.required.textField.string(),
                incorporationDate: z
                    .date({ required_error: messages.requiredField })
                    .max(today(), { message: messages.dateMustBePast })
                    .transform((date) => excludeTimeFromDate(date)),
                companyRegistrationNumber: zodSchemes.optional.textField.string.nullable(),
            })
            .passthrough(),
    })
    .passthrough();
